import { Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: ${props => props.backgroundColor};
  padding: 16px;
`;

const Banner = ({ text, backgroundColor }) => {
  return (
    <Container backgroundColor={backgroundColor}>
      {typeof text === 'string' ? <Text variant="body1Medium">{text}</Text> : text}
    </Container>
  );
};

export default Banner;
